import { createReducer } from "redux-create-reducer";

import {
  GET_MONITORING_QUEUE_ENTRY_DETAILS,
  UPDATE_CLIENT_SCORING_RESULT_STATUS,
  CREATE_WATCHLIST_IGNORING_PROPERTY,
  CLEAR_MONITORING_QUEUE_ENTRY_DETAILS,
  CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY,
} from "../types";

const initialState = {
  data: {},
  reload: {
    updateScoringSuccess: false,
    createIgnoringPropertySuccess: false,
    createNegativeMediaIgnoringPropertySuccess: false,
  },
  isLoading: false,
  isLoadingIgnoringProperties: false,
  isLoadingUpdateScoringResultStatus: false,
};

const monitoringQueueEntryDetailsReducer = createReducer(initialState, {
  [GET_MONITORING_QUEUE_ENTRY_DETAILS.DEFAULT]: (state, { payload }) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MONITORING_QUEUE_ENTRY_DETAILS.PENDING]: (state, { payload }) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MONITORING_QUEUE_ENTRY_DETAILS.REJECTED]: (state, { payload }) => ({
    ...state,
    isLoading: false,
  }),
  [GET_MONITORING_QUEUE_ENTRY_DETAILS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    reload: {
      updateScoringSuccess: false,
      createIgnoringPropertySuccess: false,
      createNegativeMediaIgnoringPropertySuccess: false,
    },
    isLoading: false,
  }),
  [CREATE_WATCHLIST_IGNORING_PROPERTY.DEFAULT]: (state) => ({
    ...state,
    isLoadingIgnoringProperties: true,
  }),
  [CREATE_WATCHLIST_IGNORING_PROPERTY.PENDING]: (state) => ({
    ...state,
    isLoadingIgnoringProperties: true,
  }),
  [CREATE_WATCHLIST_IGNORING_PROPERTY.REJECTED]: (state) => ({
    ...state,
    isLoadingIgnoringProperties: false,
  }),
  [CREATE_WATCHLIST_IGNORING_PROPERTY.FULFILLED]: (state) => ({
    ...state,
    isLoadingIgnoringProperties: false,
    reload: {
      updateScoringSuccess: false,
      createIgnoringPropertySuccess: true,
      createNegativeMediaIgnoringPropertySuccess: false,
    },
  }),

  [CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY.FULFILLED]: (
    state,
    { payload }
  ) => ({
    ...state,
    reload: {
      updateScoringSuccess: false,
      createIgnoringPropertySuccess: false,
      createNegativeMediaIgnoringPropertySuccess: true,
    },
  }),
  [UPDATE_CLIENT_SCORING_RESULT_STATUS.DEFAULT]: (state) => ({
    ...state,
    isLoadingUpdateScoringResultStatus: true,
  }),
  [UPDATE_CLIENT_SCORING_RESULT_STATUS.PENDING]: (state) => ({
    ...state,
    isLoadingUpdateScoringResultStatus: true,
  }),
  [UPDATE_CLIENT_SCORING_RESULT_STATUS.FULFILLED]: (state, { payload }) => ({
    ...state,
    isLoadingUpdateScoringResultStatus: false,
    reload: {
      updateScoringSuccess: true,
      createIgnoringPropertySuccess: false,
      createNegativeMediaIgnoringPropertySuccess: false,
    },
  }),
  [UPDATE_CLIENT_SCORING_RESULT_STATUS.REJECTED]: (state) => ({
    ...state,
    isLoadingUpdateScoringResultStatus: false,
  }),
  [CLEAR_MONITORING_QUEUE_ENTRY_DETAILS]: () => initialState,
});

export default monitoringQueueEntryDetailsReducer;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/reducers/monitoringQueueEntryDetailsReducer.js